import React, {Component} from "react"
import * as PropTypes from "prop-types"

import authentication from "@irati/auth"
import id from "@irati/utils/id"
import Flex from "@irati/ui/src/Flex"
import {Auth} from "@irati/auth/types"
import devToggles from "@irati/dev-toggles"

import {LoginDesktopPerkboxLogo, HeaderGrid, HeaderSeparator, HeaderWrapper, TenantLogo, TenantName} from "../styled"
import CurrentApp from "../shared/CurrentApp"
import MyProductAccount from "../shared/MyProductAccount"
import MySavings from "./MySavings"
import WalletMenu from "./WalletMenu/Menu"
import UserMenu from "./UserMenu/Menu"
import AdminButton from "./AdminButton"
import AdminHeader from "./AdminHeader"
import DesktopNotificationMenu from "./DesktopNotificationMenu"

interface Props {
  auth: Auth
}

class HeaderDesktop extends Component<Props> {
  static contextTypes = {
    apps: PropTypes.object.isRequired,
    appPath: PropTypes.string.isRequired
  }

  render() {
    const {auth} = this.props
    const {user, userTenant, branding} = auth
    const {appPath, apps: contextApps} = this.context
    const {SETUP_TENANT, ADMIN, PERKS, HOME, RECOGNITION} = contextApps
    const isTenantSetupSection = appPath === SETUP_TENANT
    const isAdminSection = appPath === ADMIN
    const isPerksSection = appPath === PERKS
    const isCelebrationSection = appPath === RECOGNITION
    const isHomepage = appPath === HOME
    const isLoggedIn = authentication.isLoggedIn()
    const userWalletAuth = authentication.apps("wallet.users")
    const ttWalletAuth = authentication.apps("wallet.treatTokens")
    const flexiRewardsAuth = authentication.apps("wallet.flexiRewards.view")
    const showWallet = isLoggedIn && (userWalletAuth || ttWalletAuth || flexiRewardsAuth) && !isTenantSetupSection
    const idNamespace = id("header", this.props, {force: true})
    const canEditHomepageTiles = authentication.apps("platform.homepageTiles.update")
    const hideTopRightLogo = (isHomepage && canEditHomepageTiles) || isLoggedIn

    return (
      <HeaderWrapper isAdmin={isAdminSection}>
        <HeaderGrid $isFullWidth={isLoggedIn}>
          <Flex justifyContent="space-between">
            {!isLoggedIn && <LoginDesktopPerkboxLogo />}
            {isLoggedIn && isAdminSection && <AdminHeader />}

            {isLoggedIn && (
              <Flex alignItems="center">
                {isTenantSetupSection && (
                  <>
                    <CurrentApp id={idNamespace} auth={auth} />
                    <TenantName>{userTenant.public_name}</TenantName>
                  </>
                )}
              </Flex>
            )}

            <Flex alignItems="center">
              {isLoggedIn && devToggles.showMySavings() && <MySavings />}
              {user && <MyProductAccount isPerksSection={isPerksSection} isCelebrationSection={isCelebrationSection} />}
              {showWallet && <WalletMenu id={id("link-wallet-desktop", idNamespace)} />}
              <AdminButton />
              {user && auth.productPermissions?.platform?.contentCards && <DesktopNotificationMenu />}
              {!isTenantSetupSection && user && <UserMenu id={idNamespace} user={user} />}

              {hideTopRightLogo || (
                <>
                  {isLoggedIn && <HeaderSeparator />}
                  {branding && <TenantLogo src={branding.businessLogoUrl} />}
                </>
              )}
            </Flex>
          </Flex>
        </HeaderGrid>
      </HeaderWrapper>
    )
  }
}

export default HeaderDesktop
